import React, { useContext } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Box } from "@src/components/Boxes";
import { Text } from "@src/components/Text";
import { theme } from "@src/components/nessie-web";
import Container from "@src/components/Container";
import Translate from "@src/components/translation/Translate";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import IconCard from "@src/components/FeatureTile";
import { Grid, GridItem } from "@src/components/Grid";

const Heading = ({ children }) => (
  <Text
    fontWeight="700"
    fontSize={["30px", "48px"]}
    lineHeight="1.2"
    textAlign="center"
    marginBottom="20px"
    color={theme.colors.taro90}
  >
    {children}
  </Text>
);

const Subheading = ({ children }) => (
  <Text
    fontWeight="700"
    fontSize={["18px", "24px"]}
    lineHeight="1.15"
    textAlign="center"
    marginBottom="20px"
    color={theme.colors.taro90}
  >
    {children}
  </Text>
);

const SchoolYearSection = () => {
  const {
    directus: {
      page_resources: { hero_items },
    },
  } = useStaticQuery(graphql`
    query {
      directus {
        page_resources {
          hero_items
        }
      }
    }
  `);

  const { translate } = useContext(TranslationContext);

  return (
    <Box as="section">
      <Container marginBottom={["40px", "80px"]}>
        <Box maxWidth={["100%", "100%", "83%"]} margin="auto">
          <Box marginBottom="30px" maxWidth="600px" margin="auto">
            <Heading>
              <Translate path="directus.page_resources.hero_title" />
            </Heading>
            <Subheading>
              <Translate path="directus.page_resources.hero_subtitle" />
            </Subheading>
          </Box>
          <Grid gapSize="m">
            {hero_items.map((item, index) => (
              <GridItem colSpan={[12, 4]} key={index}>
                <IconCard
                  icon={item.icon_url}
                  title={translate(`directus.page_resources.hero_items.title_${index + 1}`)}
                  description={translate(`directus.page_resources.hero_items.text_${index + 1}`)}
                  buttonLabel={translate(`directus.page_resources.hero_items.button_${index + 1}`)}
                  href={item.button_url}
                />
              </GridItem>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default SchoolYearSection;
